export default __webpack_public_path__ + "static/media/login-illustration.26ce1b6d.svg";